import { useEffect, useSyncExternalStore } from "react";
import { Logo } from "../components/Logo";
import { TEST_STR } from "./testI18n";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let listeners = [];
const getLang = () => localStorage.getItem("pjp-lang") || "en";
const setLang = (next) => { localStorage.setItem("pjp-lang", next); listeners.forEach((l) => l()); };
const subscribe = (listener) => { listeners.push(listener); return () => { listeners = listeners.filter((l) => l !== listener); }; };
const useLang = () => useSyncExternalStore(subscribe, getLang);

export const useT = () => TEST_STR[useLang()];

export const track = (type, page = "test") => {
  fetch(`${API}/test/event`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ type, page }) }).catch(() => {});
};

export const fmtTime = (sec, minLabel = "m") => `${Math.floor(sec / 60)}${minLabel} ${String(sec % 60).padStart(2, "0")}s`;

export const Shell = ({ children }) => {
  const lang = useLang();
  const T = TEST_STR[lang];
  useEffect(() => {
    const prev = document.body.style.background;
    document.body.style.background = "#ffffff";
    return () => { document.body.style.background = prev; };
  }, []);
  return (
    <div className="tp-shell">
      <div className="tp-topbar"><div className="tp-topbar-inner">
        <a className="tp-brand" href="/" data-testid="tp-brand"><Logo size={24} /><span>PRANJAL SIR <b>PHYSICS</b></span></a>
        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          <div className="lang-toggle tp-lang" role="group" aria-label="Language">
            <button type="button" className={lang === "en" ? "active" : ""} onClick={() => setLang("en")} data-testid="tp-lang-en">EN</button>
            <button type="button" className={lang === "hi" ? "active" : ""} onClick={() => setLang("hi")} data-testid="tp-lang-hi">हिंदी</button>
          </div>
          <a className="tp-back" href="/" data-testid="tp-back">{T.back}</a>
        </div>
      </div></div>
      {children}
      <div className="tp-footer"><span>{T.rights}</span><span><a href="/privacy" data-testid="tp-privacy">{T.privacy}</a> · <a href="/terms" data-testid="tp-terms">{T.terms}</a></span></div>
    </div>
  );
};
